<esa-material-button [label]="label" [icon]="icon" [type]="type" (click)="onClick($event)"> </esa-material-button>
